<script>
	import {mapGetters} from 'vuex'

	export default {
		name: 'page-component-template',
		props: {
			side: {
				type: String,
				required: true
			},
			options: {
				type: Object,
				required: false,
				default() {
					return {}
				}
			},
			title: {
				type: String,
				required: false
			}
		},
		computed: {
			...mapGetters({
				currentCase: 'getCurrentCase',
				currentPageIndex: 'getCurrentPageIndex'
			}),
		}
	}
</script>